import RouterActions from "./RouterActions";
import RouterMutations from "./RouterMutations";

const state = { redirectRoute: null };

const { actions } = RouterActions;
const { mutations } = RouterMutations;

export default {
	namespaced: true, state, actions, mutations
};
